package pl.michal_cyran.brand_hub.subpages.tutoring.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.aspectRatio
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.rotate
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaEnvelope
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.unaryMinus
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.CardStyle
import pl.michal_cyran.brand_hub.components.sections.LightBackgroundSection
import pl.michal_cyran.brand_hub.components.widgets.MarkedText
import pl.michal_cyran.brand_hub.components.widgets.NumericBadge
import pl.michal_cyran.brand_hub.components.widgets.PrimaryButton
import pl.michal_cyran.brand_hub.toSitePalette

@Composable
fun TutoringAboutMe() {
    val cm = ColorMode.current.toSitePalette()
    SimpleGrid(
        numColumns = numColumns(1, md = 2),
        modifier = Modifier
            .gap(20.px)
    ) {

        Column(
            modifier = Modifier
                .overflow(Overflow.Hidden)
                .fillMaxWidth(),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            Box(
                modifier = Modifier
                    .borderRadius(5.cssRem)
                    .overflow(Overflow.Hidden)
                    .height(500.px)

            ) {
                Image(
                    src = "me.jpg",
                    modifier = Modifier
                        .height(500.px)
                        .minWidth(0.px)
                        .objectFit(ObjectFit.Cover)
                )
            }

            Column(
                modifier = CardStyle.toModifier()
                    .padding(2.cssRem)
                    .position(Position.Relative)
                    .bottom((1.5).cssRem)
                    .left(8.cssRem)
                    .borderRadius(1.5.cssRem)
                    .maxWidth(240.px)
                    .backgroundColor(cm.cardBg)
            ) {
                H2(
                    Modifier
                        .color(cm.primary)
                        .padding(bottom = 0.px)
                        .margin(bottom = 0.px)
                        .toAttrs()
                ) {
                    Text(
                        "5+ lat"
                    )
                }
                P(
                    Modifier.fontSize(0.8.cssRem).fontWeight(500).toAttrs()
                ) {
                    Text(
                        "doświadczenia"
                    )
                }
            }
        }

        Column(
            modifier = Modifier.minWidth(0.px),
            verticalArrangement = Arrangement.spacedBy(
                16.px,
                Alignment.CenterVertically
            ),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            // ZMIANA SEO: H1 zamienione na H2 (H1 powinno być unikalne dla całej strony)
            H2 {
                Span {
                    Text(
                        "Doświadczony korepetytor z pasją do nauczania"
                    )
                }
            }

            P {
                Text(
                    "Jestem absolwentem studiów ścisłych na Uniwersytecie Jagiellońskim w Krakowie. Od ponad 5 lat jako profesjonalny korepetytor pomagam uczniom i przyszłym maturzystom przełamywać lody z królową nauk oraz światem programowania."
                )
                Br()
                Br()
                Text(
                    "Moje podejście opiera się na budowaniu pewności siebie i logicznym myśleniu. Wierzę, że każdy jest w stanie zrozumieć matematykę, jeśli tylko zagadnienia zostaną odpowiednio wytłumaczone. Podczas nauki informatyki i kodowania stawiam przede wszystkim na praktyczne projekty tworzone krok po kroku."
                )
            }
            HorizontalDivider()

            SimpleGrid(
                numColumns(base=1, md=2),
                modifier = Modifier
                    .fillMaxWidth()
                    .gap(2.cssRem),
            ) {
                NumericBadge(
                    text = "zadowolonych uczniów",
                    value = 100,
                    unit = "+",
                )
                NumericBadge(
                    text = "zdawalność matur",
                    value = 98,
                    unit = "%"
                )
            }
        }
    }
}